import { useEffect } from 'react'

const HUBSPOT_IFRAME_CONTAINER_ID = 'hubspot-messages-iframe-container'

interface HiddenElementState {
  element: HTMLElement
  displayValue: string
  displayPriority: string
}

/**
 * Hides the HubSpot chat widget while a component is mounted.
 */
export function useHideHubspotWidget() {
  useEffect(() => hideHubspotWidget(), [])
}

export function hideHubspotWidget() {
  const hiddenElements: HiddenElementState[] = []
  let isActive = true

  const hideElement = (element: HTMLElement | null) => {
    if (!element || hiddenElements.some((state) => state.element === element)) {
      return
    }

    hiddenElements.push({
      element,
      displayValue: element.style.getPropertyValue('display'),
      displayPriority: element.style.getPropertyPriority('display'),
    })
    element.style.setProperty('display', 'none', 'important')
  }

  const hideWidget = () => {
    if (!isActive) {
      return
    }

    hideElement(document.getElementById(HUBSPOT_IFRAME_CONTAINER_ID))
  }

  hideWidget()

  window.hsConversationsOnReady ??= []
  window.hsConversationsOnReady.push(hideWidget)

  const observer = new MutationObserver(hideWidget)
  observer.observe(document.body, { childList: true, subtree: true })

  return () => {
    isActive = false
    observer.disconnect()

    hiddenElements.forEach(({ element, displayValue, displayPriority }) => {
      element.style.setProperty('display', displayValue, displayPriority)
    })
  }
}
